import promise from 'es6-promise';
import axios from 'axios';
import {vm} from '@/main.js';
import {configIp} from './base';

promise.polyfill();

//访问路径
export const config = {
  baseURL: configIp.baseURL,
};
var instance = axios.create({
  baseURL: configIp.baseURL,
  withCredentials: true,
});

instance.interceptors.request.use(
  function(config) {
    return config;
  },
  function(error) {
    return Promise.reject(error);
  }
);

// 添加响应拦截器
instance.interceptors.response.use(
  function(response) {
    //部署中10000
    if (response.data.code === 10000) {
      window.sessionStorage.clear();
      sessionStorage.removeItem('loginInfo');
      vm.$router.push('/');
      return;
    }
    console.log('response.data', response.data);
    if (response.data.code == 0) {
      return Promise.resolve(response.data);
    } else if (response.data.code != 0 && response.data.code != 10000) {
      vm.$message.closeAll();
      vm.$message({
        type: 'error',
        message: response.data.msg,
        duration: 3000,
      });
      return Promise.resolve(response.data);
      // return Promise.reject(response.data);
    }
  },
  function(error) {
    // 对响应错误做点什么
    console.log(error);
    return Promise.reject(error);
  }
);

//图片认证信息图 2025年10月16日 10:50:27
export const captchaImage = (params) => {
  return instance.get('common/captchaImage', params);
};

//认证图片信息  2025年10月16日 10:50:27
export const checkImageCode = (params) => {
  return instance.post('common/checkImageCode', params);
};

//获取短信接口
export const getPhoneCode = (params) => {
  // return instance.post('common/getVerificationCode', params);
  return instance.post('common/getVerificationCodeByDZ', params); //2025年10月16日 11:13:12
};

//用户登录(使用验证码)
export const loginCode = (params) => {
  return instance.post('customer/cusUser/login_mobie', params);
};

//用户登录(使用密码登录)
export const loginPass = (params) => {
  return instance.post('customer/cusUser/login', params);
};

//退出登录
export const logOut = (params) => {
  return instance.post('customer/cusUser/logout');
};

//业务 客服  获取客户列表
export const queryCusUserInfo = (params) => {
  return instance.post('customer/sysUser/queryCusUserInfo', params);
};

//用户注册
export const register = (params) => {
  return instance.post('customer/cusUser/add', params); //注册
};

//检测输入公司名称是否重复
export const enterpriseComp = (params) => {
  return instance.post('customer/cusUser/queryIsrepeat', params); //注册
};

//用户完善信息
export const registerInformation = (params) => {
  return instance.post('customer/cusUser/save', params); //保存
};

//图片上传
export const upload = (params) => {
  return instance.post('common/upload', params);
};

//图片识别
export const uploadIdentifying = (params) => {
  return instance.post('customer/imageRecognition/photoRecognition', params);
};

//行业查询接口
export const industry = (params) => {
  return instance.post('customer/sysDict/queryList', params);
};
// 查询售后类型列表 2022年7月8日10:07:42
// export function querySaleAfterType(data) {
export const querySaleAfterType = (params) => {
  return instance.post('servepc/ruleInfo/querySaleAfterType', params);
};

//客户登记信息
export const cusConsult = (params) => {
  return instance.post('customer/cusConsult/add', params);
};

//用户注册--地址查询
export const queryaddressRegion = (params) => {
  return instance.post('customer/addressRegion/queryaddressRegion', params);
};
//修改业务员账号地址
export const updateDistrict = (params) => {
  return instance.post('customer/cusUser/update/district', params);
};

//忘记密码
export const forgetPassword = (params) => {
  return instance.post('customer/cusUser/forgetPassword', params);
};

//修改密码
export const modifyPassword = (params) => {
  return instance.post('customer/cusUser/modifyPassword', params);
};

//弹窗广告
export const queryLatesttime = (params) => {
  return instance.post('customer/popupAd/queryLatesttime', params);
};

//未审核订单查询
export const orderList1 = (params) => {
  return instance.post('customer/orderDraft/queryPage', params);
};

//客户端未审核订单详情查询
export const orderList1Detail = (params) => {
  return instance.post('customer/orderDraft/query', params);
};

//除未审核订单外所有订单查询
export const orderList2 = (params) => {
  params['sysUserId'] = '';
  return instance.post('customer/order/queryBycusUserId', params);
};

//客户端查看订单详情(除未审核外)
export const orderList2Detail = (params) => {
  return instance.post('customer/order/getOrderById', params);
};

//订单评价接口
export const orderEvaluateAdd = (params) => {
  return instance.post('customer/orderEvaluate/add', params);
};

//产品类型树形下拉列表
export const productTypeSub = (params) => {
  return instance.post('customer/productTypeSub/productTreeQuery', params);
};

//查询企业信息
export const enterprise = (params) => {
  return instance.post('customer/cusUser/query/enterprise', params);
};

//查询用户所有优惠券
export const cusCouponPack = (params) => {
  return instance.post('customer/cusCouponPack/queryPage', params);
};

//企业信息修改
export const updateEnterprise = (params) => {
  return instance.post('customer/cusUser/update/enterprise', params);
};

//客户端消息查询
export const messageRecord = (params) => {
  return instance.post('customer/messageRecord/getMessageRecordByCusUser', params);
};

//产品查询
export const productQuery = (params) => {
  return instance.post('customer/product/queryPage', params);
};

//产品详情查询
export const productDetail = (params) => {
  return instance.post('customer/product/query', params);
};

//用户地址分页查询接口
export const cusUserAddress = (params) => {
  return instance.post('customer/cusUserAddress/queryPage', params);
};

//用户地址添加接口
export const cusUserAddressAdd = (params) => {
  return instance.post('customer/cusUserAddress/add', params);
};

//用户地址删除接口
export const cusUserAddressDelete = (params) => {
  return instance.post('customer/cusUserAddress/delete', params);
};

//用户地址编辑接口
export const cusUserAddressUpdate = (params) => {
  return instance.post('customer/cusUserAddress/update', params);
};

//特殊工艺下拉列表查询
export const specialProcessList = (params) => {
  return instance.post('customer/specialProcess/queryList', params);
};

//计算公式
export const productTypeValuation = (params) => {
  return instance.post('customer/productType/valuation', params);
};

//生成报价接口
export const orderDraft = (params) => {
  return instance.post('customer/order/createOffer', params);
};

//保存订单接口
export const orderDraftAdd = (params) => {
  return instance.post('customer/orderDraft/add', params);
};

//单个删除子订单
export const orderDelete = (params) => {
  return instance.post('customer/ordersSub/delete', params);
};

//删除大订单
export const deleteOrder = (params) => {
  return instance.post('customer/order/delete', params);
};

//获取制作周期
export const getExpensetByAmount = (params) => {
  return instance.post('customer/order/expenseItem/getExpensetByAmount', params);
};

//提交审核接口
export const orderAdd = (params) => {
  return instance.post('customer/order/add', params);
};

//查询单个订单信息接口
export const orderQuery = (params) => {
  return instance.post('customer/order/query', params);
};

//七牛云 图片 服务
export const qiniu = (params) => {
  return instance.post('common/qiniu/upload', params);
};

//支付宝接口调用
export const alipayCreateQr = (params) => {
  return instance.post('customer/alipay/createQr', params);
};

//申请售后接口
export const saleAfterApplyAdd = (params) => {
  return instance.post('customer/saleAfterApply/add', params);
};
//申请售后接口 2022年7月8日14:34:03
export const addSaleAfterApply = (params) => {
  return instance.post('servepc/saleAfterApply/addSaleAfterApply', params);
};

//退单申请接口
export const refundApplyAdd = (params) => {
  return instance.post('customer/refundApply/add', params);
};

//订单信息接口(订单表)
export const getMessageRecordByCusUser = (params) => {
  return instance.post('customer/orderEvaluate/getOrderByOrderNo', params);
};

//订单信息接口(草稿表)
export const getInfoByOrderNo = (params) => {
  return instance.post('customer/orderDraft/getInfoByOrderNo', params);
};

//根据产品id 查 父级信息
export const getInfoByProductId = (params) => {
  return instance.post('customer/product/getInfoByProductId', params);
};

//草稿订单修改接口
export const orderDraftUpdate = (params) => {
  return instance.post('customer/orderDraft/update', params);
};
//计算定金支付的金额
export const calOrderHandlePrice = (params) => {
  return instance.post('customer/order/calOrderHandlePrice', params);
};
//草稿订单修改接口
export const orderDraftUpdates = (params) => {
  return instance.post('customer/order/update', params);
};

//子订单修改
export const ordersSubUpdate = (params) => {
  return instance.post('customer/ordersSub/update', params);
};

//报价单中 修改子订单套数
export const calOrderNum = (params) => {
  return instance.post('customer/productType/calOrderNum', params);
};

//已完成收货，未评价的订单
export const needEvaluateOrder = (params) => {
  return instance.post('customer/orderEvaluate/needEvaluateOrder', params);
};

// 获取用户未评价订单
export const queryEvaluateOrderByUserId = (params) => {
  return instance.post('customer/orderEvaluate/queryEvaluateOrderByUserId', params);
};

// 查询用户是否存在未评价订单
export const queryNotEvaluateOrder = (params) => {
  return instance.post('customer/orderEvaluate/notEvaluateOrder', params);
};

// 登录弹窗有未评价订单时调用此接口
export const orderEvaluateCountUpdate = (params) => {
  return instance.post('customer/orderEvaluateCount/update', params);
};

//退款申请查询接口
export const refundApplyQueryPage = (params) => {
  return instance.post('customer/refundApply/queryPage', params);
};

//一直请求 ，查询 该订单 是否满足 申请退款退货接口
export const refundApplyGetRefund = (params) => {
  return instance.post('customer/refundApply/getRefund', params);
};

//草稿表订单删除
export const orderDraftDelete = (params) => {
  return instance.post('customer/orderDraft/delete', params);
};

//是否有新消息
export const getNewMessage = (params) => {
  return instance.post('customer/messageRecord/getNewMessage', params).catch((error) => {
    console.log(error);
  });
};

//是否有新消息可用优惠券
export const getNewCusCouponPack = (params) => {
  return instance.post('customer/cusCouponPack/getNewCusCouponPack', params).catch((error) => {
    console.log(error);
  });
};

//获取报价项子颜色
export const getProductByChildren = (params) => {
  return instance.post('customer/productItem/getProductByChildren', params);
};

//获取使用包装与电源费用
export const usePowerSupply = (params) => {
  return instance.post('customer/order/usePowerSupply', params);
};

//紧急撤单(付款后当天上午可撤单)
export const cancellationOrder = (params) => {
  return instance.post('customer/cancellationOrder/add', params);
};

// //登录弹窗有未评价订单时调用此接口
// export const orderEvaluateCountUpdate = (params) => {
//     return instance.post('customer/orderEvaluateCount/update', params)
// }

//获取产品厚度系数
export const queryPage = () => {
  return instance.post('customer/expensesDetails/queryPage', {
    type: 'f974bc4ad9b34e1ba16d236538d56a9f',
  });
};
//获取业务员
export const queryCusSysUser = (params) => {
  return instance.post('customer/cusUser/queryCusSysUser', params);
};
//配置电源安装位置个数
export const installNumber = (params) => {
  return instance.post('customer/order/installNumber', params);
};
//保存识别图片记录
export const addImage = (params) => {
  return instance.post('customer/identificationRecord/add', params);
};
//获取子订单数据
export const querySubOrder = (params) => {
  return instance.post('customer/order/querySubOrder', params);
};
//客户分销信息
export const queryMyDistributor = (params) => {
  return instance.post('customer/cusDistributor/queryMyDistributor', params);
};
//用户佣金明细
export const queryCommissionsDetail = (params) => {
  return instance.post('customer/cusDistributor/queryCommissionsDetail', params);
};
//分销商详情信息
export const queryCusDistributorInfo = (params) => {
  return instance.post('customer/cusDistributor/query', params);
};
//分销业绩详情
export const queryMyperformanceOrders = (params) => {
  return instance.post('customer/performanceOrders/queryMyperformanceOrders', params);
};
//分销客户详情
export const queryMyCusDistributorDetail = (params) => {
  return instance.post('customer/cusDistributor/queryMyCusDistributorDetail', params);
};
//确定订单使用蟠桃
export const determineCommissionOrder = (params) => {
  return instance.post('customer/order/determineCommissionOrder', params);
};
//根据子订单总价计算预计折后金额
export const displayDiscount = (params) => {
  return instance.post('customer/order/displayDiscount', params);
};
//根据优惠券金额获取最优蟠桃使用个数
export const getAvailableCommission = (params) => {
  return instance.post('customer/order/getAvailableCommission', params);
};
//跳转支付宝支付
export const alipayComputerpay = (params) => {
  return instance.post('customer/alipay/computerpay', params);
};
//一直请求售后接口
export const getSaleAfterApply = (params) => {
  return instance.post('customer/saleAfterApply/getSaleAfterApply', params);
};
//一直请求售后接口
export const determineCouponOrder = (params) => {
  return instance.post('customer/order/determineCouponOrder', params);
};
//一直请求售后接口
export const cancelOrder = (params) => {
  return instance.post('customer/order/orderCancel', params);
};
//修改提示次数接口
export const updateAlert = (params) => {
  return instance.post('customer/cusUser/update/alertNumber', params);
};
//查询题目
export const subjectsQueryPage = (params) => {
  return instance.post('customer/subjects/queryPage', params);
};
//修改分销商考核信息
export const distributorAssessmentUpdate = (params) => {
  return instance.post('customer/subjects/dAAdd', params);
};
//根据省市地址查询地区
export const queryRegionalByCity = (params) => {
  return instance.post('customer/cusUserAddress/queryRegionalByCity', params);
};
//查询投诉标签
export const labelComplaintQueryPage = (params) => {
  return instance.post('customer/serve/labelComplaint/queryPage', params);
};
//新增投诉记录
export const complaintRecordAdd = (params) => {
  return instance.post('customer/serve/complaintRecord/add', params);
};
//查询分销规则配置
export const distributionRuleQueryPage = (params) => {
  return instance.post('customer/serve/distributionRule/queryPage', params);
};
//获取业务员成员
export const departmentList = (params) => {
  return instance.post('customer/sysUser/frontSystemUser', params);
};
//获取业务员客户
export const queryCusUser = (params) => {
  return instance.post('customer/cusUser/queryCusUser', params);
};
//线下订单修改
export const offlineOrders = (params) => {
  return instance.post('customer/offlineOrders/update', params);
};
//线下订单付款方式
export const querySysDictList = (params) => {
  return instance.post('customer/sysDict/queryList', params);
};
//获取优惠券
export const setCoupon = (params) => {
  return instance.post('customer/order/setCoupon', params);
};
//获取单品券可使用子产品类型
export const queryDetailCoupon = (params) => {
  return instance.post('customer/cusCouponPack/queryDetailCoupon', params);
};
//获取日历假期
export const restDay = (params) => {
  return instance.post('customer/restDay/queryPage', params);
};
//取消退款
export const refundApplyDelete = (params) => {
  return instance.post('customer/refundApply/delete', params);
};
//取消售后
export const saleAfterApplyDelete = (params) => {
  return instance.post('customer/saleAfterApply/delete', params);
};
//取消紧急撤单
export const cancellationOrderDelete = (params) => {
  return instance.post('customer/cancellationOrder/delete', params);
};
//产品修改名称提示
export const productUpdateNameRecordQuery = (params) => {
  return instance.post('customer/serve/productUpdateNameRecord/query', params);
};
//产品修改名称提示确定修改提示
export const productUpdateAlertAdd = (params) => {
  return instance.post('customer/serve/productUpdateAlert/add', params);
};
//新增申请工厂信息
export const ftApplicationFormAdd = (params) => {
  return instance.post('customer/ftApplicationForm/add', params);
};
//验证申请加盟表手机号及公司名称是否存在
export const ftApplicationFormCheckInfo = (params) => {
  return instance.post('customer/ftApplicationForm/checkInfo', params);
};
//查询所有表面工艺
export const specialProcessQueryList = (params) => {
  return instance.post('customer/specialProcess/queryList', params);
};
//查询首页海报图
export const advertisingPicturesQueryList = (params) => {
  return instance.post('customer/serve/advertisingPictures/queryPage', params);
};
//多文件上传(图片)
export const uploadBatch = (params) => {
  return instance.post('common/uploadBatch', params);
};
//计算报价项关联表面处理价格
export const setProductItemProcess = (params) => {
  return instance.post('customer/productType/setProductItemProcess', params);
};
//修改退款状态（确定退款金额）
export const updateToStatus = (params) => {
  return instance.post('customer/refundApply/updateToStatus', params);
};
//获取物流下拉选择的信息
export const sysDictQueryList = (params) => {
  return instance.post('customer/sysDict/queryList', params);
};
//去凭证支付
export const upVoucherToOrder = (params) => {
  return instance.post('customer/order/upVoucherToOrder', params);
};
//去凭证支付
export const getOperationDevlierByOrderId = (params) => {
  return instance.post('customer/order/getOperationDevlierByOrderId', params);
};
//获取订单可关联子订单
export const getOrderAssembleRelation = (params) => {
  return instance.post('customer/ordersSub/getOrderAssembleRelation', params);
};
//确定关联信息
export const bindingOrderSub = (params) => {
  return instance.post('customer/ordersSub/bindingOrderSub', params);
};
//判断订单是否已经关联
export const getOrderIsRelation = (params) => {
  return instance.post('customer/ordersSub/getOrderIsRelation', params);
};
//获取当前时间
export const queryCurrentTime = (
  params = {
    front: true,
  }
) => {
  return instance.post('customer/restDay/queryCurrentTime', params);
};
//获取电话是否已注册
export const isCusUsers = (params) => {
  return instance.post('customer/cusUser/isCusUsers', params);
};
//图片编辑-生成订单信息
export const createOrderInfo = (params) => {
  return instance.post('customer/order/createOrderInfo', params);
};

// =========================================================================
//cdr生成图片 再 生成原始识别字体图片
// export const createNumImage = (params) => {
//     return instance.post('/speedbao/sqOrderPicInfo/createNumImage', params)
// }

//获取用户所在套餐信息
export const getUserVipPower = (params) => {
  return instance.post('/speedbao/sqUserVipInfo/getUserVipPower', params);
};

//添加用户活跃记录
export const addActive = (params) => {
  return instance.post('/speedbao/sqUser/addActive', {
    ...params,
    useClient: 2,
  });
};

// //图片上传
// export const upload = (params) => {
//     return instance.post('common/upload', params)
// }

//获取报价列表  订单列表（报价单列表）
export const getOrderList = (params) => {
  return instance.post('/speedbao/sqOrder/getOrderList', params);
};

//获取 报价单 详情
export const getOrderInfoById = (params) => {
  return instance.post('/speedbao/sqOrder/getOrderInfoById', params).then((res) => {
    return res.data;
  });
};
//获取 该工厂的 产品类型 下拉
export const productTreeQuery = (params) => {
  return instance.post('/speedbao/sqProductTypeSub/productTreeQuery', params);
};

//修改报价单产品类型
export const calculationTypeByUpdateProduct = (params) => {
  return instance.post('/speedbao/sqProductTypeSubInterval/calculationTypeByUpdateProduct', params);
};

//修改报价单字类型
export const calWordByGroupUpdateType = (params) => {
  return instance.post('/speedbao/sqProductTypeSubInterval/calWordByGroupUpdateType', params);
};

//修改报价单单价  (可多个)
export const calWordByGroupUpdatePrice = (params) => {
  return instance.post('/speedbao/sqProductTypeSubInterval/calWordByGroupUpdatePrice', params);
};

//修改报价单行套数(可多行修改)
export const calWordByGroupUpdateNum = (params) => {
  return instance.post('/speedbao/sqProductTypeSubInterval/calWordByGroupUpdateNum', params);
};

//报价单删除行数据(可多行删除)
export const deleteAll = (params) => {
  return instance.post('/speedbao/sqProductTypeSubInterval/deleteAll', params);
};

//获取附加费用列表
export const queryListCosts = (params) => {
  return instance.post('/speedbao/sqAdditionalCosts/queryList', params);
};

//新建附加费用(用户单个)
export const costsAdd = (params) => {
  return instance.post('/speedbao/sqFactoryAdditionalCosts/add', params);
};

//删除附加费用(用户单个)
export const costsDelete = (params) => {
  return instance.post('/speedbao/sqFactoryAdditionalCosts/delete', params);
};

//添加订单费用信息
export const addCosts = (params) => {
  return instance.post('/speedbao/sqOrderAdditionalCosts/addCosts', params);
};

//获取优惠和折扣 列表
export const queryDiscountList = (params) => {
  return instance.post('/speedbao/sqAdditionalCosts/queryDiscountList', params);
};

//新增报价工厂优惠信息 折扣信息
export const addDiscount = (params) => {
  return instance.post('/speedbao/sqAdditionalCosts/addDiscount', params);
};

//删除报价工厂优惠信息 折扣信息
export const deleteDiscount = (params) => {
  return instance.post('/speedbao/sqAdditionalCosts/deleteDiscount', params);
};

//添加订单优惠信息
export const sqOrderAddDiscount = (params) => {
  return instance.post('/speedbao/sqOrder/addDiscount', params);
};

//修改报价单备注信息
export const updateBigOrder = (params) => {
  return instance.post('/speedbao/sqOrder/updateBigOrder', params);
};

// 保存产品高度信息（创建订单合并）  尺寸估价
export const calculationType = (params) => {
  return instance.post('/speedbao/sqProductTypeSubInterval/calculationType', params);
};

//删除报价单  大订单
export const deleteOrderById = (params) => {
  return instance.post('/speedbao/sqOrder/deleteOrderById', params);
};

//删除子订单
export const deleteSubOrderById = (params) => {
  return instance.post('/speedbao/sqOrder/deleteSubOrderById', params);
};

//报价单 按组还是按个排列 查询
export const getSubOrderInfoById = (params) => {
  return instance.post('/speedbao/sqOrder/getSubOrderInfoById', params).then((res) => {
    return res.data;
  });
};
//获取报价单中对应的字体坐标信息
export const getOrderWordSort = (params) => {
  return instance.post('/speedbao/sqOrder/getOrderWordSort', params).then((res) => {
    return res.data;
  });
};

//修改字体计价量
export const calWordByGroupUpdateHeight = (params) => {
  return instance.post('/speedbao/sqProductTypeSubInterval/calWordByGroupUpdateHeight', params);
};

//生成 Execl 表格
export const createExecl = (params) => {
  return instance.post('/speedbao/sqOrderPicInfo/createExecl', params);
};

//查询用户信息
export const sqUserQuery = (params) => {
  return instance.post('/speedbao/sqUser/query', params);
};

//查询用户会员信息
export const getUserWallet = (params) => {
  return instance.post('/speedbao/sqUserWallet/getUserWallet', params);
};

//查询用户备注列表
export const getRemarksList = (params) => {
  return instance.post('/speedbao/sqAdditionalCosts/getRemarksList', params);
};

//用户备注列表新增
export const configRemarks = (params) => {
  return instance.post('/speedbao/sqFactory/configRemarks', params);
};

//用户备注列表删除
export const deleteOrUpdateRemarks = (params) => {
  return instance.post('/speedbao/sqFactory/deleteOrUpdateRemarks', params);
};

//获取通告栏内容
export const getRuleInfo = (params) => {
  return instance.post('/speedbao/sqRuleInfo/getRuleInfo', params);
};

//删除单个订单优惠信息
export const sqOrderDeleteDiscount = (params) => {
  return instance.post('/speedbao/sqOrder/deleteDiscount', params);
};

//删除单个订单费用信息
export const sqOrderAdditionalCostsDelete = (params) => {
  return instance.post('/speedbao/sqOrderAdditionalCosts/delete', params);
};

//获取报价单列表
export const getOrderListByMainUser = (params) => {
  return instance.post('/speedbao/sqOrder/getOrderListByMainUser', params);
};

//修改大报价单状态
export const updateBigStatus = (params) => {
  return instance.post('/speedbao/sqOrder/updateStatus', params);
};

//回款或退款操作
export const operationMoney = (params) => {
  return instance.post('/speedbao/sqOrder/operationMoney', params);
};

//用户是否会员过期
export const isOverTime = (params) => {
  return instance.post('/speedbao/sqUser/isOverTime', params);
};

//获取客户列表
export const getCustomerNameList = (params) => {
  return instance.post('/speedbao/sqAdditionalCosts/getCustomerNameList', params);
};

//编辑客户名称
export const sqFactoryAdditionalCostsUpdate = (params) => {
  return instance.post('/speedbao/sqFactoryAdditionalCosts/update', params);
};

//新增客户名称
export const configCustomerName = (params) => {
  return instance.post('/speedbao/sqFactory/configCustomerName', params);
};

//新增用户教程提示次数
export const insertCourseCount = (params) => {
  return instance.post('/speedbao/sqUser/insertCourseCount', params);
};

//获取用户的教程提示次数
export const getUserCourseInfo = (params) => {
  return instance.post('/speedbao/sqUser/getUserCourseInfo', params);
};

//配置用户图片显示类型
export const updatePicType = (params) => {
  return instance.post('/speedbao/sqOrder/updatePicType', params);
};

// =========================================================================

//查看报价单
export const cusGetOrderInfoById = (params) => {
  return instance.post('/customer/ordersSubPicInfo/getOrderInfoById', params);
};
export const createNumImage = (params) => {
  return instance.post('/customer/ordersSubPicInfo/createNumImage', params);
};
//修改用户图片显示类型
export const changePicType = (params) => {
  return instance.post('/customer/cusUser/changePicType', params);
};
//修改订单备注信息
export const changeRemark = (params) => {
  return instance.post('/customer/order/changeRemark', params);
};
//修改字体类型
export const calWordPrice = (params) => {
  return instance.post('/customer/productType/calWordPrice', params);
};
//  报价单中 查询子产品类型 中的报价项 id
export const queryItemInfo = (params) => {
  return instance.post('/customer/productItem/queryItemInfo', params);
};
//  报价单中 修改子订单表面处理信息
export const calSpecialPrice = (params) => {
  return instance.post('/customer/productType/calSpecialPrice', params);
};
//  报价单中 修改子订单排列方式
export const changePicSotrType = (params) => {
  return instance.post('/customer/ordersSubPicInfo/changePicSotrType', params);
};
//  报价单中 修改子订单报价项信息
export const calProductItemPrice = (params) => {
  return instance.post('/customer/productType/calProductItemPrice', params);
};
//  报价单中 修改子订单产品类型
export const calOrderProductType = (params) => {
  return instance.post('/customer/productType/calOrderProductType', params);
};
//  报价单中 获取产品分类订单信息
export const getOrderSubListWord = (params) => {
  return instance.post('/customer/ordersSubPicInfo/getOrderSubListWord', params);
};
//  报价单中 子产品分类
export const calSplitProductType = (params) => {
  return instance.post('/customer/productType/calSplitProductType', params);
};
//  报价单中 删除报价单子订单信息
export const deleteOrderSub = (params) => {
  return instance.post('/customer/ordersSub/deleteOrderSub', params);
};
//  报价单中 删除报价单行信息
export const deleteRowInfo = (params) => {
  return instance.post('/customer/ordersSub/deleteRowInfo', params);
};
//  报价单中 生成报价单图片
export const createImage = (params) => {
  return instance.post('/customer/ordersSubPicInfo/createImage', params);
};
//  报价单中 生成报价单execl
export const createExcel = (params) => {
  return instance.post('/customer/ordersSubPicInfo/createExcel', params);
};
//查询客户信息 - 切换账号的信息
export const getCusUserInfo = (params) => {
  return instance.post('/customer/cusUser/getCusUserInfo', params);
};
// 前端直接上传文件的接口
export const uploadGetToken = (params) => {
  return instance.post('/common/file/getToken', params);
};



// WEBPACK FOOTER //
// ./src/api/index.js